import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import styles from './Modal.module.scss';
import { ApplicantActions, jobProfileActions, } from '../../../actions';
import CommentPage from '../../HistoryComponents/Comment';

export default function ReferredProfileModal({
  visible,
  toggle,
  currentModalIndex,
  setCurrentModalIndex,
  selectedRoundCardsLength,
  showPrevNext,
  ...props
}) {

  const [options, setOptions] = useState([]);
  const [jobId, setJobId] = useState('');
  const [selectedId, setSelectedId] = useState('');
  const [callSendComment, setCallSendComment] = useState(false);
  
  const jobProfiles = useSelector((state) => state.jobProfiles.jobData);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(jobProfileActions.getjobIds()); 
  },[])


  useEffect(() => {
    if (jobProfiles && jobProfiles.length > 0) {
        let resVal = [];
        jobProfiles?.map((val) => {
          val.job_profile.map((job) => {
            resVal.push({
              value: job?.id,
              pId: val?.id,
              label: `${val.name} - ${job?.jobTitle}`,
            });
          });
        });
        setOptions(resVal);
    }
  }, [jobProfiles]);

  useEffect(() => {
    if (!visible) {
      setJobId('');
    }
  }, [visible]);

  function selectChnage(option) {
  setJobId(option?.value);
  }

  const handleButtonClick = () => {
    const req = {
      id: props.candidateId ? props.candidateId : props.cloneCandidateId,
      jobId: jobId,  
    };
    if (props.candidateId) {
      dispatch(ApplicantActions.moveDynamicReferral(req));  
      toggle();
    } else if (props.cloneCandidateId) {
      dispatch(ApplicantActions.cloneJobProfile(req))
      .then((res) => {
        console.log(res);
        setSelectedId(res?.jobAppid)
        setCallSendComment(true);
        toggle();
      })
      .catch((e) => {
        console.log(e);
      });
      // toggle();
    }
  };
  

  return (
    <Modal
      isOpen={visible}
      toggle={toggle}
      centered
      size={props.size ? props.size : 'lg'}
      backdrop='static'
    >
      <ModalHeader className='modal-title border-0 pb-1' toggle={toggle}>
        {
          props.cloneCandidateId ? "Applicant cloning for different job profiles" : "Move to the job board"
        }
      </ModalHeader>
      <ModalBody>
        <div className='mb-4'>
          <Select
            options={options}
            name='selectJob'
            value={options.find((option) => String(option.value) === String(jobId)) || null}
            onChange={selectChnage}
            placeholder='Select Job'
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
                borderRadius: '0.5rem',
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected
                  ? '#CBD9EA'
                  : 'transparent',
                borderRadius: '0.3rem',
                color: 'black',
              }),
            }}
          />
        </div>

        {
          props.cloneCandidateId &&
          <CommentPage
            selectedId={selectedId}
            cloneJob={true}
            callSendComment={callSendComment}
            setCallSendComment={setCallSendComment}
        />
        }
        
        <div className='col-12 d-flex align-items-center justify-content-end pt-2'>
          <button
            type='submit'
            className={styles.btnRefer + ' btn w-auto'}
            onClick={handleButtonClick}
            disabled={jobId === ""}
          >
            Submit
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}
